module.exports = __webpack_public_path__ + "img/vuetify.6b484e8c.png";